
import React, { Component } from 'react';
import ResolutionDropdown from 'components/effects/ResolutionDropdown.js';
import { connect } from "react-redux";
import MiniTrackComponent from './MiniTrackComponent.js';

class TrackDocumentation extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        return (
            <div className="track-documentation">
              <p>
                The step sequencer is responsible for sequencing samples and instruments. By default, 16 steps are shown-- one for each 1/16th step in a bar.
              </p>
              <MiniTrackComponent sequencerEngine={this.props.sequencerEngine}/>
             <p className="sub-header">
                Step Basics
              </p>
              <ul>
                <li>
                  <b>Click</b> on a step to toggle it on or off. Toggled steps are triggered by the sequencer, when the sequencer is playing.
                </li>
                <li>
                  <b>Command + Click</b> or <b>Alt + Click</b> a step to show editable parameters for that step.
                </li>
                <li>
                  The blinking step is called the <b>cursor</b>. You can move it using arrow-keys.
                </li>
                <li>
                  The <b>shift</b> key hides the parameters at the <b>cursor</b>.
                </li>
                <li>
                  The <b>enter</b> key toggles the step at the <b>cursor</b>.
                </li>
                <li>
                  The <b>spacebar</b> starts/stops the sequencer.
                </li>
                <li>
                  The blue line underneath the steps is the playhead, and tells you where in the loop the sequencer is triggering.
                </li>
              </ul>
              <p>
                Each step can be edited in a number of ways. 
              </p>
             <p className="sub-header">
                Changing Step Duration
              </p>
              <p>
                <b>Drag</b> the right edge of a toggled step to alter it's duration.
              </p>
              <p>
                As you alter the duration, notice that the color behind the steps changes. This visualizes the durations of the steps.
              </p>
             <p className="sub-header">
                Editing Step Parameters
              </p>
              <p>
                <b>Command/Alt + Click</b> a step to edit the parameters for the step. The parameters shown include:
                <ul>
                  <li>
                    <b>Duration</b>: the length of the trigger (in 1/16th notes).
                  </li>
                  <li>
                    <b>Chop</b>: How many times within the duration it will re-trigger. E.g. A duration of 2 with chop=3 will split the duration 2 into 3 triggers.
                  </li>
                  <li>
                    <b>Velocity</b>: Volume of the trigger.
                  </li>
                  <li>
                    <b>Transpose</b>: The pitch of the trigger. Note that higher and lower transposes will trigger the sample faster and slower, respectively. Transpose 0 is C3.
                  </li>
                  <li>
                    <b>Slice</b>: which sample slice in the sample to trigger. Check the <b>Track Details</b> documentation, for how to slice samples.
                  </li>
                  <li>
                    <b>Panning</b>: the stereo-panning from left-to-right to trigger at. -1 is left, 1 is right, 0 is center.
                  </li>
                </ul>
              </p>
              <p className="sub-header">
                Moving, Copying and Pasting Steps
              </p>
              <p>
                Select multiple steps by by dragging through the steps you wish to select. Once steps are selected you can:
                <ul>
                  <li>Move them around.</li>
                  <li>Copy and paste them (via <b>CMD+c</b> and <b>CMD+v</b>)</li>
                  <li>Delete them (via the <b>delete</b> key)</li>
                </ul>
              </p>
              <p>
                Move a single step by simply <b>dragging</b> it.
              </p>
              <p>
                <b>Command+A</b> or <b>Ctrl+A</b> selects every step on the selected track.
              </p>
              <p className="sub-header">
                Changing the Length of a Track
              </p>
              <p>
                The colored <b>+</b> and <b>-</b> buttons-- beneath the steps-- double and half the track-length, respectively. Each track can have any "length" they wish.
              </p>
              <p>
                The <b>Len.</b> button toggles <b>Track Length Mode</b>. When in this mode, you can choose the exact length of the track. This is mainly used when you wish to choose a non-standard length, that can't be chosen via the <b>+</b> and <b>-</b> buttons.
              </p>
           </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
    };
};
 
export default connect(mapStateToProps, undefined)(TrackDocumentation);
